import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><g stroke="#000" fill="none" fillRule="evenodd"><path strokeWidth="2" d="M13 0h11v11" /><path d="M24 10L10 24 0 14 14 0" /><circle cx="18" cy="6" r="2" /></g></svg>;